import { render, staticRenderFns } from "./RenseignementsGeneraux.vue?vue&type=template&id=ae1b9252"
import script from "./RenseignementsGeneraux.vue?vue&type=script&lang=js"
export * from "./RenseignementsGeneraux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports